"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallPromise = void 0;
const ObservablePromise_1 = require("./ObservablePromise");
class CallPromise extends ObservablePromise_1.ObservablePromise {
    constructor(api, method, parser, name) {
        super(api[method].bind(api), parser, name || method.toString());
        this.api = api;
        this.method = method;
    }
    clone() {
        return new CallPromise(this.api, this.method, this._parser, this.name);
    }
}
exports.CallPromise = CallPromise;
